export default function CopyLineIcon({
  width = 16,
  height = 16,
  fill = '#CE181E',
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66653 3.9987V1.9987C4.66653 1.63051 4.96501 1.33203 5.3332 1.33203H13.3332C13.7014 1.33203 13.9999 1.63051 13.9999 1.9987V11.332C13.9999 11.7002 13.7014 11.9987 13.3332 11.9987H11.3332V13.9981C11.3332 14.3666 11.0333 14.6654 10.662 14.6654H2.67111C2.30039 14.6654 2 14.369 2 13.9981L2.00173 4.66594C2.0018 4.29744 2.30176 3.9987 2.67295 3.9987H4.66653ZM3.33495 5.33203L3.33346 13.332H9.99987V5.33203H3.33495ZM5.99987 3.9987H11.3332V10.6654H12.6665V2.66536H5.99987V3.9987Z"
        fill={fill}
      />
    </svg>
  );
}
